export default __webpack_public_path__ + "static/media/appai_logo_dark.3f1596b5.svg";